import i18n from 'sharedKernel/i18n/translate/config'
import type { ScoutingCriterionDefinition } from '../api/scoutingService'
import { isScoutingSelectionFieldId, SCOUTING_OPTIONS_BY_FIELD, SCOUTING_SELECTION_FIELD_ORDER } from './constants'
import { findScoutingCriterionDefinitionId } from './criterionDefinitionMatch'
import type { ScoutingSelectionFieldId } from './types'
import { trimUnknownToString } from 'sharedKernel/utils'

const pickOptionDisplayLabel = (
  fieldId: ScoutingSelectionFieldId,
  stored: string
): string | undefined => {
  const hit = SCOUTING_OPTIONS_BY_FIELD[fieldId].find(
    (o) => o.value === stored || o.label === stored
  )
  return hit?.label ? String(i18n.t(hit.label)) : undefined
}

const displayLabelFromAnyField = (stored: string): string => {
  const v = trimUnknownToString(stored)
  if (!v) return ''
  for (const fieldId of SCOUTING_SELECTION_FIELD_ORDER) {
    const label = pickOptionDisplayLabel(fieldId, v)
    if (label) return label
  }
  return v
}

export const labelForScoutingSelectionValue = (fieldId: string, value: string): string => {
  const v = trimUnknownToString(value)
  if (!v || !isScoutingSelectionFieldId(fieldId)) return v
  return pickOptionDisplayLabel(fieldId, v) ?? v
}

export const formatScoutingCriteriaForDisplay = (
  criteria: Array<{ scoutingCriterionId?: string | number; valueOne?: unknown }> | undefined,
  definitions: ScoutingCriterionDefinition[] | undefined
): string => {
  if (!criteria?.length) return ''

  if (definitions?.length) {
    const parts: string[] = []
    for (const fieldId of SCOUTING_SELECTION_FIELD_ORDER) {
      const defId = findScoutingCriterionDefinitionId(definitions, fieldId)
      if (!defId) continue
      const row = criteria.find((c) => String(c.scoutingCriterionId) === String(defId))
      const text = labelForScoutingSelectionValue(fieldId, trimUnknownToString(row?.valueOne))
      if (text) parts.push(text)
    }
    if (parts.length > 0) return parts.join(' | ')
  }

  return criteria
    .map((c) => displayLabelFromAnyField(trimUnknownToString(c.valueOne)))
    .filter(Boolean)
    .join(' | ')
}
